import { css } from "@emotion/react";

export const nodeEditorStyle = css`
  border: 1px solid #1890ff;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
`;
